// messages.js
const $ = window.jQuery || {};

class Messages {
  // singleton
  static #instance = null;

  constructor() {
    if (Messages.#instance) {
      return Messages.#instance;
    }
    Messages.#instance = this;
  }

  showSuccess($element, message) {
    $element.html(message).show();
    setTimeout(() => {
      $("#success-message").hide();
    }, 15000);
  }

  showError($element, message) {
    $element.text(message).show();
    setTimeout(() => {
      $("#error-message").hide();
    }, 15000);
  }
}

export default Messages;
